const prefix = "homeCache:v1:"
const keys = ["calendar", "upcoming", "courses", "contracts", "balance", "slider", "stats", "courseDay", "daycareDay"]
const maxLength = 64 * 1024
const maxAge = 24 * 60 * 60 * 1000
const statKeys = ["currentIst", "currentPlan", "prevIst", "diffAbs", "today", "yesterday", "open"]
const dayFormat = new Intl.DateTimeFormat("en-CA", { timeZone: "Europe/Zurich", year: "numeric", month: "2-digit", day: "2-digit" })

function owner() {
  if (!localStorage.getItem("token")) return null
  return JSON.parse(localStorage.getItem("user"))?.user?._id || null
}

function validScope(scope) {
  const parts = JSON.parse(scope)
  const userId = owner()
  return Boolean(userId && Array.isArray(parts) && parts[0] === userId && parts[1] && parts.includes(dayFormat.format(new Date())))
}

function validData(key, data) {
  const records = (value) => Array.isArray(value) && value.every((item) => item && typeof item === "object")
  if (key === "courseDay") return records(data) && data.every((course) => course._id && course.course && records(course.instructors) && [course.hours, course.minutes, course.duration].every((value) => Number.isFinite(Number(value))))
  if (key === "daycareDay") {
    const validTime = (value) => typeof value === "string" && /^(?:[01]\d|2[0-3])[0-5]\d$/.test(value)
    const settings = data?.settings
    const validHours = settings === null || (typeof settings?.active === "boolean" && settings.days && typeof settings.days === "object" && Object.values(settings.days).every((slots) => records(slots) && slots.every((slot) => !slot.isOpen || (validTime(slot.open) && validTime(slot.close)))))
    return data && validHours && data.signups && typeof data.signups.signedUp === "boolean" && ["amount", "signedUpAmount", "signedUpBabiesAmount"].every((key) => Number.isFinite(data.signups[key]))
  }
  if (key === "calendar") return records(data) && data.every((day) => Number.isFinite(day.ts) && typeof day.short === "string")
  if (key === "upcoming") return records(data) && data.every((course) => typeof course.startAt === "string")
  if (key === "courses") return records(data) && data.every((course) => course._id && course.course && typeof course.course === "object")
  if (key === "contracts") return data && records(data.contracts) && data.contracts.every((contract) => Number.isFinite(contract.startDateObj) && Number.isFinite(contract.endDateObj) && Array.isArray(contract.addons) && contract.details)
  if (key === "balance") return data && typeof data.balance === "string"
  if (key === "stats") return data && statKeys.every((key) => Number.isFinite(data[key]))
  if (key === "slider") return data && data.groups && ["parties", "events", "main"].every((source) => records(data.groups[source]) && data.groups[source].every((slide) => typeof slide.image === "string"))
  return false
}

export function readHomeCache(key, scope) {
  if (!keys.includes(key)) return null
  try {
    const raw = localStorage.getItem(prefix + key)
    if (!raw) return null
    if (raw.length > maxLength) throw new Error("Oversized snapshot")
    const snapshot = JSON.parse(raw)
    const age = Date.now() - snapshot.savedAt
    if (!Number.isFinite(age) || age < 0 || age > maxAge || !validScope(snapshot.scope) || !validData(key, snapshot.data)) {
      localStorage.removeItem(prefix + key)
      return null
    }
    return !scope || snapshot.scope === scope ? snapshot.data : null
  } catch (_) {
    try { localStorage.removeItem(prefix + key) } catch (_) {}
    return null
  }
}

export function saveHomeCache(key, scope, data) {
  if (!keys.includes(key)) return
  try {
    if (!validScope(scope) || !validData(key, data)) return
    const raw = JSON.stringify({ scope, savedAt: Date.now(), data })
    if (raw.length > maxLength) {
      localStorage.removeItem(prefix + key)
      return
    }
    localStorage.setItem(prefix + key, raw)
  } catch (_) { /* Storage is optional; keep using the in-memory data. */ }
}

export function removeHomeCache(key, scope) {
  if (!keys.includes(key)) return
  try {
    const raw = localStorage.getItem(prefix + key)
    if (!scope || !raw || JSON.parse(raw).scope === scope) localStorage.removeItem(prefix + key)
  } catch (_) {}
}

export function clearHomeCaches() {
  keys.forEach((key) => removeHomeCache(key))
  try { sessionStorage.removeItem("homeMiniStats:v1") } catch (_) {}
}

export function pruneHomeCaches() {
  // Also handles legacy logout flows that remove the token and reload the page.
  keys.forEach((key) => readHomeCache(key))
}
